/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  CancelPolicyStatusPlugin,
  ICancelPolicyStatusPluginMethods,
  FeatureSectionPlugin,
  IFeatureSectionPluginMethods,
  FooterPlugin,
  IFooterPluginMethods,
  FormatPolicyStatusPlugin,
  IFormatPolicyStatusPluginMethods,
  FormatTimelineStatusPlugin,
  IFormatTimelineStatusPluginMethods,
  GetTransactionListPlugin,
  IGetTransactionListPluginMethods,
  HeaderProvisionalDetailPlugin,
  IHeaderProvisionalDetailPluginMethods,
  StaticProvisionalDetailPlugin,
  IStaticProvisionalDetailPluginMethods,
  UpdateKYCStatusPlugin,
  IUpdateKYCStatusPluginMethods,
  UpdatePaymentPlugin,
  IUpdatePaymentPluginMethods,
  ErrorProvisionalDetailContentPlugin,
  IErrorProvisionalDetailContentPluginMethods,
  LoadingProvisionalDetailPlugin,
  ILoadingProvisionalDetailPluginMethods,
} from './plugins';

export type TAgent = ICancelPolicyStatusPluginMethods &
  IFeatureSectionPluginMethods &
  IFooterPluginMethods &
  IFormatPolicyStatusPluginMethods &
  IFormatTimelineStatusPluginMethods &
  IGetTransactionListPluginMethods &
  IHeaderProvisionalDetailPluginMethods &
  IStaticProvisionalDetailPluginMethods &
  IUpdateKYCStatusPluginMethods &
  IUpdatePaymentPluginMethods &
  IErrorProvisionalDetailContentPluginMethods &
  ILoadingProvisionalDetailPluginMethods;
const getPlugins = () => {
  return [
    new StaticProvisionalDetailPlugin(),
    new ErrorProvisionalDetailContentPlugin(),
    new LoadingProvisionalDetailPlugin(),
    //Business logic plugins !
    new CancelPolicyStatusPlugin(),
    new FeatureSectionPlugin(),
    new FooterPlugin(),
    new FormatPolicyStatusPlugin(),
    new GetTransactionListPlugin(),
    new HeaderProvisionalDetailPlugin(),
    new UpdateKYCStatusPlugin(),
    new UpdatePaymentPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
